export enum BankCardErrorCodeTypes {
    // 通用校验错误
    NEED_COMPLETE_ACH_AUTH = 'CUSTOM_ERROR_NEED_COMPLETE_ACH_AUTH' // 需要认证
}

export const customErrorMsgMap: Record<BankCardErrorCodeTypes, string> = {
    CUSTOM_ERROR_NEED_COMPLETE_ACH_AUTH: __('You have missing information. Please add first.')
};
